import React from 'react';
export function StockWarning() {
  return <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-sm mb-4" data-id="element-411">
      <div className="flex items-center" data-id="element-412">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500 mr-2" viewBox="0 0 20 20" fill="currentColor" data-id="element-413">
          <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" data-id="element-414" />
        </svg>
        <p className="font-medium text-red-700" data-id="element-415">
          ENDAST <span className="font-bold" data-id="element-416">7 BURKAR</span> KVAR I LAGER!
          <span className="block mt-1 text-xs" data-id="element-417">
            (Senast någon i <span className="underline" data-id="element-418">ditt område</span> köpte
            var för 7 minuter sedan)
          </span>
        </p>
      </div>
    </div>;
}